import { TOAST_DISABLED, TOAST_TOGGLE } from "../type";

export const toastToggleAction = (data) => ({ type: TOAST_TOGGLE, payload: data })
export const toastDisabledAction = () => ({ type: TOAST_DISABLED })